import VueChartJs from 'vue-chartjs'

export const LineChart = {
    extends: VueChartJs.Line,
    mixins: [VueChartJs.mixins.reactiveProp],
    props: ['labels', 'yMax'],
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                },
                tooltips: {
                    displayColors: false
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            color: "rgba(0, 0, 0, 0.08)"
                        },
                        scaleLabel: this.labels.x
                    }],
                    yAxes: [{
                        ticks: {
                            min: 0,
                            suggestedMax: this.yMax || 100,
                            // stepSize: 20
                        },
                        gridLines: {
                            color: "rgba(0, 0, 0, 0.08)"
                        },
                        scaleLabel: this.labels.y
                    }]
                }
            }
        }
    },
    watch: {
        height: {
            handler(newData, oldData) {
                this.render()
            },
            deep: true
        },
        width: {
            handler(newData, oldData) {
                this.render()
            },
            deep: true
        },
        chartData: {
            handler(newData, oldData) {
                if (oldData && JSON.stringify(newData.labels) == JSON.stringify(oldData.labels)) {
                    return;
                }
                this.render();
            },
            deep: true
        },
        labels: {
            handler(newData, oldData) {
                this.render()
            },
            deep: true
        },
    },
    methods: {
        render() {
            this.chartData.datasets.map(dat => {
                dat.label = dat.translationKey;
                dat.borderColor = dat.borderColor ? dat.borderColor : '#26dad2'
                dat.borderWidth = 1.5
                dat.pointStyle = 'circle'
                dat.pointBackgroundColor = dat.pointBackgroundColor ? dat.pointBackgroundColor : '#26dad2'
                dat.pointRadius = 5
                dat.pointHoverBackgroundColor = dat.pointHoverBackgroundColor ? dat.pointHoverBackgroundColor : '#26dad2'
                dat.pointHoverRadius = 7
                dat.pointBorderColor = 'transparent'
                dat.pointBorderWidth = 0
                dat.pointHoverBorderColor = 'transparent'
                dat.pointHoverBorderWidth = 0
                if (dat.hasOwnProperty('gradientBackground')) {
                    let gradient = dat.gradientBackground
                    delete dat.gradientBackground
                    let step = Math.floor(100 / gradient.length) / 100
                    var grad = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450),
                        i = 0
                    for (var j = 0; j < gradient.length; j++) {
                        grad.addColorStop(i, gradient[j])
                        i += step
                    }
                    dat.backgroundColor = grad
                }
            })
            this.options.scales.xAxes = [{
                gridLines: {
                    color: "rgba(0, 0, 0, 0.08)"
                },
                scaleLabel: this.labels.x
            }]

            this.options.scales.yAxes = [{
                ticks: {
                    min: 0,
                    suggestedMax: this.yMax || 100,
                    stepSize: null
                },
                gridLines: {
                    color: "rgba(0, 0, 0, 0.08)"
                },
                scaleLabel: this.labels.y
            }]
            this.renderChart(this.chartData, this.options)
        }
    },
    mounted() {
        this.render()
    }
}

export const BarChart = {
    extends: VueChartJs.Bar,
    mixins: [VueChartJs.mixins.reactiveProp],
    props: ['labels', 'yMax', 'yMin', 'stepSize'],
    // mixins: [VueChartJs.mixins.reactiveProp],
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                },
                tooltips: {
                    displayColors: false
                },
                scales: {
                    xAxes: [{
                        barThickness: 12,
                        gridLines: {
                            color: "rgba(0, 0, 0, 0.08)"
                        },
                        ticks: {
                            display: true
                        },
                        // scaleLabel: this.labels.x
                    }],
                    yAxes: [{
                        ticks: {
                            min: this.yMin || 0,
                            suggestedMax: this.yMax || 100,
                            // stepSize: 20
                        },
                        gridLines: {
                            color: "rgba(0, 0, 0, 0.08)"
                        },
                        // scaleLabel: this.labels.y
                    }]
                }
            }
        }
    },
    watch: {
        height: {
            handler(newData, oldData) {
                this.render()
            },
            deep: true
        },
        width: {
            handler(newData, oldData) {
                this.render()
            },
            deep: true
        },
        chartData: {
            handler(newData, oldData) {
                if (oldData && JSON.stringify(newData.labels) == JSON.stringify(oldData.labels)) {
                    return;
                }
                this.render();
            },
            deep: true
        },
        labels: {
            handler(newData, oldData) {
                this.render()
            },
            deep: true
        }
    },
    methods: {
        render() {
            this.chartData.datasets.map(dat => {
                let currentLabel = dat.label;
                dat.label = dat.translationKey;
                if (!dat.label) {
                    // fallback to previous label if loading of translated label fails
                    dat.label = currentLabel;
                }
            });
            this.renderChart(this.chartData, this.options)
        }
    },
    mounted() {
        this.render()
    }
}


export const PieChart = {
    extends: VueChartJs.Pie,
    props: {
        chartData: {
            required: true
        },
        options: {
            required: false
        }
    },
    // mixins: [VueChartJs.mixins.reactiveProp],
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                },
                tooltips: {
                    displayColors: false
                },
                animation: {
                    duration: 0
                },
                hover: {
                    animationDuration: 0
                },
                responsiveAnimationDuration: 0
            }
        }
    },
    watch: {
        height: {
            handler(newData, oldData) {
                this.render()
            },
            deep: true
        },
        width: {
            handler(newData, oldData) {
                this.render()
            },
            deep: true
        },
        chartData: {
            handler(newData, oldData) {
                if (oldData && JSON.stringify(newData.labels) == JSON.stringify(oldData.labels)) {
                    return;
                }
                this.render();
            },
            deep: true
        }
    },
    methods: {
        render() {
            this.renderChart(this.chartData, this.options)
        }
    },
    mounted() {
        this.render()
    }
}




// WEBPACK FOOTER //
// ./resources/js/components/ChartJS.js